import HttpService from './Http2'

const http = new HttpService({})

export default http
